import { useEffect, useState, useRef } from "react";
import { WalletIcon } from "../../assets/Icons";
import defaultPerfil from "../../assets/Icons/default-perfil.png";
import SettingsIcon from "../../assets/Icons/SettingIcon";
import styles from "./style.scss";
import { ExtractSection } from "../../components/ExtractSection";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Settings } from "../../components/Settings";

import jwtDecode from "jwt-decode";
import { useContext } from "react";
import { toast } from "react-toastify";
import ExclamationIcon from "../../assets/Icons/ExclamationIcon";
import Exit from "../../assets/Icons/Exit";
import Upload from "../../assets/Icons/Upload";
import FaqModal from "../../components/FaqModal";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import PointsTransferModal from "../../components/PointsTransferModal";
import { RescueHistory } from "../../components/RescueHistory";
import RescueModal from "../../components/RescueModal";
import { AxiosProvider } from "../../connections/config";
import axios from "axios";
import context from "../../context/context";
import formatName from "../../Helpers/FormatName";
export default function Extract() {
  const {
    userToken,
    logout,
    extracts,
    approved,
    pending,
    loadExtract,
    loading,
    loadCashbackHistory,
    cashbackHistory,
    postRescue,
    setLoading,
    user,
    setUser,
    colors,
  } = useContext(context);

  const [navType, setNavType] = useState("extract");
  const [open, setOpen] = useState(false);
  const [faqType, setFaqType] = useState("p");
  const [openRecue, setOpenRecue] = useState(false);
  const [openPointsTransfer, setOpenPointsTransfer] = useState(false);
  const [hasPointPrograms, setHasPointPrograms] = useState(false);
  const [userPrograms, setUserPrograms] = useState([]);
  const [isCheckingPrograms, setIsCheckingPrograms] = useState(false);
  const hasCheckedPrograms = useRef(false);

  async function refecthFunctions() {
    await Promise.all([loadCashbackHistory(), loadExtract()]);
  }

  async function checkUserPrograms() {
    if (!userToken || isCheckingPrograms) {
      return;
    }

    setIsCheckingPrograms(true);
    
    try {
      // Decodifica o token para pegar o apiKey
      const decodedToken = jwtDecode(userToken);
      const apiKey = decodedToken?.selectedCompany?.code || '';
      
      if (!apiKey) {
        setHasPointPrograms(false);
        setIsCheckingPrograms(false);
        return;
      }

      // Usa uma instância isolada do axios para não afetar o interceptor global
      const response = await axios.get(
        "https://api-points.clubecerto.com.br/point-programs/programs-by-user",
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'x-api-key': apiKey,
            'local': 'web',
          },
        }
      );

      if (response.data && response.data.count > 0) {
        setHasPointPrograms(true);
        setUserPrograms(response.data.rows || []);
      } else {
        setHasPointPrograms(false);
        setUserPrograms([]);
      }
    } catch (error) {
      // Silenciosamente define como false se houver erro
      // Não loga o erro para não poluir o console
      setHasPointPrograms(false);
      setUserPrograms([]);
    } finally {
      setIsCheckingPrograms(false);
    }
  }
  async function rescueSubmit() {
    const rescue = await postRescue();
    if (!rescue) {
      setOpenRecue(false);
      return;
    }
    await refecthFunctions();
    setOpenRecue(false);
    toast.success(
      <>
        Saldo solicitado para resgate <br /> Aguarde até <b>2 dias úteis </b>
        para aprovação
      </>
    );
  }

  useEffect(() => {
    // Reset o flag quando o token mudar
    if (!userToken) {
      hasCheckedPrograms.current = false;
    }
    
    const initializeData = async () => {
      setLoading(true);
      await refecthFunctions();
      if (userToken && !hasCheckedPrograms.current) {
        hasCheckedPrograms.current = true;
        await checkUserPrograms();
      }
      setLoading(false);
    };

    initializeData();
  }, [userToken]);

  return (
    <>
      <Header />
      <div
        className="greenContainer"
        style={{
          background: colors.backgroundColor
            ? `linear-gradient(92.05deg, ${colors.backgroundColor} 1.8%, #01160d 94.62%)`
            : "linear-gradient(92.05deg, #569a59 1.8%, #01160d 94.62%)",
        }}
      >
        <div className="perfilContainer">
          {user?.userImage ? (
            <div
              style={{
                width: 110,
                height: 110,
                borderRadius: "50%",
                backgroundImage: `url(${user?.userImage})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            />
          ) : (
            <img alt="defaultProfile" src={defaultPerfil} width={110} />
          )}
          <h2>{user?.name ? formatName(user?.name) : ""}</h2>
        </div>
        <div className="valuesContainer">
          <div>
            <h1>{`R$${approved.toFixed(2).replace(".", ",")}`}</h1>
            <h3>Dísponivel</h3>
            <div className="RescueContainer">
              <button
                onClick={() => {
                  if (hasPointPrograms) {
                    setOpenPointsTransfer(true);
                  } else {
                    setOpenRecue(true);
                  }
                }}
                disabled={hasPointPrograms ? false : Number(approved) >= 20 ? false : true}
                style={{
                  background:
                    hasPointPrograms || Number(approved) >= 20 ? colors.backgroundColor : null,
                }}
              >
                {hasPointPrograms ? "Transferir para Pontos" : "Resgatar"}
              </button>
              <ExclamationIcon
                onClick={() => {
                  setFaqType("d");
                  setOpen(true);
                }}
              />
            </div>
          </div>
          <div>
            <h1>{`R$${pending.toFixed(2).replace(".", ",")}`}</h1>
            <h3>Pendente</h3>
            <ExclamationIcon
              onClick={() => {
                setFaqType("p");
                setOpen(true);
              }}
            />
          </div>
        </div>
      </div>
      <div className="mainContainer">
        <ul>
          <li
            onClick={() => {
              setNavType("extract");
            }}
            style={
              navType === "extract" && colors.backgroundColor
                ? {
                    background: colors.backgroundColor,
                    color: "#fff",
                  }
                : navType === "extract" && !colors.backgroundColor
                ? { background: "#569A59", color: "#fff" }
                : null
            }
          >
            <WalletIcon
              color={navType === "extract" ? "#fff" : colors.backgroundColor}
            />
            Extrato de Cashback
          </li>
          <li
            onClick={() => {
              setNavType("rescueHistory");
            }}
            style={
              navType === "rescueHistory" && colors.backgroundColor
                ? {
                    background: colors.backgroundColor,
                    color: "#fff",
                  }
                : navType === "rescueHistory" && !colors.backgroundColor
                ? { background: "#569A59", color: "#fff" }
                : null
            }
          >
            <Upload
              color={
                navType === "rescueHistory"
                  ? "#fff"
                  : colors.backgroundColor || "#569A59"
              }
            />
            Resgates Cashback
          </li>
          <li
            onClick={() => {
              setNavType("settings");
            }}
            style={
              navType === "settings" && colors.backgroundColor
                ? {
                    background: colors.backgroundColor,
                    color: "#fff",
                  }
                : navType === "settings" && !colors.backgroundColor
                ? { background: "#569A59", color: "#fff" }
                : null
            }
          >
            <SettingsIcon
              color={
                navType === "settings"
                  ? "#fff"
                  : colors.backgroundColor || "#569A59"
              }
            />
            Configurações
          </li>
          <li
            onClick={() => {
              logout();
            }}
          >
            <Exit color={colors.backgroundColor} />
            Sair
          </li>
        </ul>
        {navType === "extract" && <ExtractSection extracts={extracts} />}
        {navType === "settings" && <Settings user={user} setUser={setUser} />}
        {navType === "rescueHistory" && (
          <RescueHistory extracts={cashbackHistory} />
        )}
      </div>
      <Footer />
      {loading ? <Loader /> : <></>}
      <Modal open={open} onClose={() => setOpen(false)}>
        <FaqModal setOpen={setOpen} faqType={faqType} />
      </Modal>
      <Modal open={openRecue} onClose={() => setOpenRecue(false)}>
        <RescueModal
          setOpen={setOpenRecue}
          value={approved}
          handleSubmit={rescueSubmit}
        />
      </Modal>
      <PointsTransferModal
        open={openPointsTransfer}
        setOpen={setOpenPointsTransfer}
        cashbackValue={approved}
        userToken={userToken}
        userId={user?.id || jwtDecode(userToken)?.userId}
        userCpf={user?.cpf || jwtDecode(userToken)?.cpf}
        onTransferSuccess={refecthFunctions}
        colors={colors}
        initialPrograms={userPrograms}
      />
    </>
  );
}
